/*
 * Author: zhanghj
 * Date: 2020-09-23 10:28:01
 * LastEditors: zhanghj
 * LastEditTime: 2021-01-07 13:49:17
*/
import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      // 此处可以写成组件，当组件崩溃后，可以替换崩溃的组件
      console.log('React Error');
      // router.push('/404')
    }
    return this.props.children;
  }
}
